import { getFormattedCost } from './get-formatted-cost';

// TODO: Разобраться со вью компонентов, форматировать даты при получении, где это не происхоит
export const getFormattedDisplayCost = (cost: number): string => {
  if (!cost && cost !== 0) {
    return '-';
  }

  return getFormattedCost(cost);
};
